import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UserRegisterComponent } from '../user-register/user-register.component';
import { PasswordRecoveryComponent } from './password-recovery/password-recovery.component';
import { AuthService } from '../../services/apis/platform/auth.service';
import { UtilService } from '../../services/util.service';
import { UsuarioLoginResponse } from '../../services/responses/platform/usuario-login.response';
import { AlertService, AlertType } from '../../services/alert.service';
import { ShoppingCartService } from '../../services/apis/platform/shopping-cart.service';
import { ReturnStruct } from '../../services/structs/return.struct';

@Component({
  selector: 'app-login',
  imports: [ 
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogContent,
    MatProgressSpinnerModule,
    MatIconModule,
    MatProgressSpinnerModule, 
    CommonModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit{
  
  public model: FormGroup;
  public _isLoading = false;
  private ip: string = '192.168.0.2';

  constructor(private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<LoginComponent>,
    public authService:AuthService,
    public utilService:UtilService,
    public alertService:AlertService,
    public shoppingCartService:ShoppingCartService
  ){  
  }

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });

    this.getIP();
  }

  
  hideSenha = signal(true);
  clickEventSenha1(event: MouseEvent): void {
    this.hideSenha.set(!this.hideSenha());
    event.stopPropagation();
  }

  login(){
    if (this.model.invalid || this._isLoading) {
      return;
    }

    this._isLoading = true;
    let email:string = this.model.get("email")?.value;
    let password:string = this.model.get("password")?.value;

    this.authService.signIn(email, password, this.ip).subscribe({
      next: (response: UsuarioLoginResponse) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this._isLoading = false;
          return;
        }

        this.authService.updateToken(response);
        this._isLoading = false;

        //Atualzia o carrinho
        this.shoppingCartService.addToCart().subscribe({
          next: (response: ReturnStruct) => {
            if (response.isError) {
              this.alertService.show('Erro', response.errorDescription, AlertType.error);
              this._isLoading = false;
              return;
            }

            //reload na tela
            window.location.reload();
          },
          error: error => {
            this.alertService.show('Erro inesperado', error.message, AlertType.error);
            this._isLoading = false;
          },
        });

        this.dialogRef.close();
      },
      error: error => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  getIP(): void {
    this.utilService.getIP().subscribe({
      next: response => {
        if (response && response.ip) {
          this.ip = response.ip;
        }
      },
    });
  }

  forgotPassword(){
    this.dialogRef.close();

    const dialogRef = this.dialog.open(PasswordRecoveryComponent, {
      data: {},
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
      }
    });
  }

  openModalRegister(){
    this.dialogRef.close();
    const dialogRef = this.dialog.open(UserRegisterComponent, {
      data: {},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        window.location.reload();
      }
    });
  }
}
